/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardDefinitionAclContext {
    getFixupPrototypeFunction() { return DashboardDefinitionAclContext.fixupPrototype; }

    static newInstance(model: Partial<DashboardDefinitionAclContext>): DashboardDefinitionAclContext {
        let obj = Object.assign(new DashboardDefinitionAclContext(), model);
        DashboardDefinitionAclContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardDefinitionAclContext>): DashboardDefinitionAclContext {
        if (!model) return null;
        return DashboardDefinitionAclContext.newInstance(<DashboardDefinitionAclContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardDefinitionAclContext) {
        if (!obj) return;

        models.DashboardDefinitionAclContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardDefinitionAclContext): boolean {
        Object.setPrototypeOf(obj, DashboardDefinitionAclContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.role_types) {
            for (let val of this.role_types) {
                models.DashboardDefinitionAclRoleType.fixupPrototype(val);
            }
        }
        if (this.roles) {
            for (let val of this.roles) {
                models.DashboardDefinitionAclRole.fixupPrototype(val);
            }
        }
        if (this.accounts) {
            for (let val of this.accounts) {
                models.DashboardDefinitionAclContextDetails.fixupPrototype(val);
            }
        }
        if (this.tenants) {
            for (let val of this.tenants) {
                models.DashboardDefinitionAclContextDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * True if user has product admin role
     */
    is_product_admin: boolean;

    /**
     * True if user has account admin role
     */
    is_account_admin: boolean;

    /**
     * Product bundles for the user
     */
    product_bundles: Array<string>;

    /**
     * Role types for the user
     */
    role_types: Array<models.DashboardDefinitionAclRoleType>;

    /**
     * Roles for the user
     */
    roles: Array<models.DashboardDefinitionAclRole>;

    /**
     * Accounts for the user
     */
    accounts: Array<models.DashboardDefinitionAclContextDetails>;

    /**
     * Tenants for the user
     */
    tenants: Array<models.DashboardDefinitionAclContextDetails>;

}
